var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWaveEnd = function SvgWaveEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 205"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d27979",
    d: "m0 192 80-16c80-16 240-48 400-37.3 160 10.3 320 64.3 480 64 160 .3 320-53.7 400-80l80-26.7V0H0Z"
  })));
};

export { SvgWaveEnd as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTQ0MCAyMDUiPjxwYXRoIGZpbGw9IiNkMjc5NzkiIGZpbGwtb3BhY2l0eT0iMSIgZD0iTTAsMTkyTDgwLDE3NkMxNjAsMTYwLDMyMCwxMjgsNDgwLDEzOC43QzY0MCwxNDksODAwLDIwMyw5NjAsMjAyLjdDMTEyMCwyMDMsMTI4MCwxNDksMTM2MCwxMjIuN0wxNDQwLDk2TDE0NDAsMEwxMzYwLDBDMTI4MCwwLDExMjAsMCw5NjAsMEM4MDAsMCw2NDAsMCw0ODAsMEMzMjAsMCwxNjAsMCw4MCwwTDAsMFoiPjwvcGF0aD48L3N2Zz4K";